/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Generates a random string based on a given set of characters.
 * @param {Number} length The length of the generated string
 * @param {String} chars All possible characters in the generated string - defaults to lowercase alphanumeric
 * @returns The generated random string (eg. xy2c8b)
 */
export const generateRandomString = (length, chars = '0123456789abcdefghijklmnopqrstuvwxyz') => {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
};
